import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/';

class UserService {
    getTechnicians() {
        return axioscommon.get(API_URL + 'techs', { headers: authHeader() });
    }
    getUsers() {
        return axioscommon.get(API_URL + 'users', { headers: authHeader() });
    }
    getRoles() {
        return axioscommon.get(API_URL + 'roles', { headers: authHeader() });
    }
    updateUser(id, data) {
        return axioscommon.put(API_URL + 'users/' + id, data, { headers: authHeader() });
    }
    changePassword(data) {
        return axioscommon.post(API_URL + 'auth/changepass', data, { headers: authHeader() });
    }
    changeMyPass(data) {
        return axioscommon.post(API_URL + 'auth/changemypass/' + data, null, { headers: authHeader() });
    }
    forgotPassword(data) {
        return axioscommon.post(API_URL + 'auth/forgotpassword', data, { headers: authHeader() });
    }
}

export default new UserService();
